import Bandwidth from './Bandwidth'
import Config from './Config'
import ConfigShow from './ConfigShow'
import ServerWarehouse from './ServerWarehouse'
import Warehouse from './Warehouse'

const Component = {
    bandwidth: Bandwidth,
    'base-config': Config,
    'view-config': ConfigShow,
    transcoding: Bandwidth,
    warehouse: Warehouse,
    'server-warehouse': ServerWarehouse,
}

export default Component
